<template>
  <div class="mt-main-panel">
    <div class="mt-main-panel__header">
      <div class="mt-main-panel__stats">
        <div class="mt-main-panel__stats-row">
          <div>
            <r-text type="caption">
              Активно объектов на карте
            </r-text>
          </div>
          <div>
            <r-text type="caption">
              {{ vehiclesCount }}
            </r-text>
          </div>
        </div>
        <div class="mt-main-panel__stats-row">
          <div>
            <r-text type="caption">
              Нет геометрии
            </r-text>
          </div>
          <div>
            <r-text type="caption">
              {{ vehiclesWithoutGeomCount }}
            </r-text>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-main-panel__vehicles">
      <r-button
        icon="list"
        @click="toggleVehicleList"
      >
        Показать список объектов
      </r-button>
    </div>
    <div class="mt-main-panel__filters">
      <filters />
    </div>
  </div>
</template>

<script>
import Filters from '../filters/filters'

export default {
  components: {
    Filters
  },
  computed: {
    isVehicleListOpened: {
      get() {
        return this.$store.state.monitoring.isVehicleListOpened
      },
      set(value) {
        this.$store.commit('SET_MT_FIELD', {
          field: 'isVehicleListOpened',
          value
        })
      }
    },
    vehiclesCount() {
      return this.$store.state.monitoring.vehiclesCount
    },
    vehiclesWithoutGeomCount() {
      return this.$store.state.monitoring.vehiclesWithoutGeomCount
    }
  },
  methods: {
    toggleVehicleList() {
      this.isVehicleListOpened = !this.isVehicleListOpened
    }
  }
}
</script>

<style lang="scss" scoped>
.mt-main-panel {
  padding: 8px;
  height: 100%;
  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid transparent;
    border-color: var(--dividers_low_contrast) !important;
    padding-bottom: 8px;
  }

  &__stats {
    width: 100%;

    &-row {
      display: flex;
      justify-content: space-between;

      &:not(:first-child) {
        margin-top: 8px;
      }
    }
  }

  &__vehicles {
    padding: 8px 0;

    .r-button {
      width: 100%;
    }
  }

  &__filters {
    flex: 1;
    overflow: auto;
  }
}
</style>
